/* eslint-disable no-multi-assign */
/* eslint-disable no-restricted-properties */
/* eslint-disable import/prefer-default-export */
import get from 'lodash/get'
import range from 'lodash/range'
import set from 'lodash/set'
import isArray from 'lodash/isArray'
import moment from 'moment'
import { addLocale } from 'primereact/api';

import htmlTemplates from '@staticTemplate/htmlTemplates';

import { catalogoClass } from '@constants/seccion'
import enviroment from '@constants/enviroment'
import { LANGUAGE_DEFAULT, DAY_NAMES, MONTH_NAMES, AUTHORIZATION, DATA_USER, MAIN_CLASS_HTML_DIGITAL_FORM, SECTION_TEMPLATE_TYPES } from '@constants/general'
import { TypeDocuments } from '@constants/documents'
import i18n from '../i18n';

export const rexgexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const regexOnlyNumbersAndLetters = /[^0-9a-zA-Z]/

export const getEnvironment = (env) => {
  if (window?.env?.[env]) return window?.env?.[env]
  return enviroment[env]
}

function encodeQueryData (data) {
  let ret = []
  for(let d in data) {
    if (encodeURIComponent(data[d]) !== 'undefined') {
      ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]))
    }
  }
  return ret.join('&')
}

export const urlQueryData = (url, queryParams) => {
  if (typeof queryParams === 'object') {
    if(Object.keys(queryParams).length === 0) return url
    if (url.includes('?')) return url + encodeQueryData(queryParams)
    return url + '?' + encodeQueryData(queryParams)
  } else if (typeof queryParams === 'string') {
    return url + '?' + queryParams
  } else {
    return url
  }
}

export const cleanStorageAuth = () => {
  localStorage.removeItem(AUTHORIZATION)
  sessionStorage.removeItem(DATA_USER)
  window.setValueToIframe("")
  return true
};

export const setAuthAdmin = ({accessToken, ...restData}) => {
  if (accessToken) {
    window.setValueToIframe(accessToken)

    localStorage.setItem(AUTHORIZATION, accessToken)
  }
  sessionStorage.setItem(DATA_USER, JSON.stringify(restData))
  return {accessToken, ...restData};
};

export const validateValuesLanguages = (objLanguage) => {
  Object.keys(objLanguage).map(key => {
    if (!objLanguage[key]) delete objLanguage[key]
  })
  return objLanguage
}

export const downloadFile = (url, filename) => {
  var blob = new Blob([url])
  var link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.download = filename
  link.click()
}

export const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))  } ${  sizes[i]}`;
}

export const mainClassForSection = () => catalogoClass.map(item => item.parentClass.class)

export const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});

export const getBase64Image = (dataurl, filename) => {
  const arr = dataurl.split(','); const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]); let n = bstr.length; const u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {type:mime});
}

export const loadCSS = ( element ) => new Promise( ( resolve, _reject ) => {
    const link = document.createElement( 'link' );
    link.rel  = 'stylesheet';
    link.type = "text/css"
    link.media = "screen"
    link.href = '/layout/css/styles.css';
    element.appendChild( link );
    link.onload = function() { 
        resolve(); 
    };
})

export const loadJS = ( body )=> {
  const js = document.createElement("script");
  js.type = "text/javascript";
  js.src = '/layout/js/index.js'

  return body.appendChild(js);
}

const getContainerOneElement = (getElement, item, cleanLayout) => {
  const currentContainer = getElement && getElement.length ? getElement[0] : null
  let element = currentContainer
    ? currentContainer.querySelector(`.${item.containerOneClass}`)
    : null

  if (!element && cleanLayout) {
    const cleanContainer = cleanLayout.getElementsByClassName(item.class)[0]
    if (cleanContainer) element = cleanContainer.querySelector(`.${item.containerOneClass}`)
  }

  return element
}

export const setValuesIntoHtmlSection = async ({item, cloneLayout, state, language, isChild = false, index, cleanLayout}) => {
  const getElement = cloneLayout.getElementsByClassName(item.class)

  const data = {
    value:item.valueState,
    language,
    defaultValue: item.defaultValue,
    stateGeneral: state
  }
  // START ptions extra
  if(item.class === "sct-banner-code-ethics-btn"){
    getElement[0].setAttribute('data-language', language)
  }
  // END options extra
  if (isChild) data.index = index
  const getValue = validateStateValue(data)
  if (item.childrenClass) {
    if (item.isCarousel) {
      setCarouselIndicators(getValue, item, cloneLayout)
      // const quatityIndicators = getValue.length / item.optionCarousel.itemsBySlider
      const foramatData = getValue.reduce((accum, data, index) => {
        if (index % item.optionCarousel.itemsBySlider === 0 ) {
          accum.push([{...data, originIndex: index}])
        } else {
          accum[accum.length - 1].push({...data, originIndex: index})
        }
        return accum
      },[])
      const copyC = getContainerOneElement(getElement, item, cleanLayout)
      if (!copyC) return false
      const copyContainer = copyC.cloneNode(true)
      
      const copyI = copyContainer.querySelector(`.${item.optionCarousel.classitem}`).cloneNode(true);
      const copyItem = copyI.cloneNode(true)
      getElement[0].innerHTML = ""
      copyContainer.innerHTML = ""

      const carouselContainers = await Promise.all(foramatData.map(async (grouop, indexGroup) => {
        const newContainer = copyContainer.cloneNode(true)
        if ( indexGroup > 0) newContainer.classList.remove("active");
        const carouselItems = await Promise.all(grouop.map(async data => {
          const newItem = copyItem.cloneNode(true)
          await Promise.all(item.childrenClass.map(option => setValuesIntoHtmlSection({
              item: option,
              cloneLayout: newItem,
              state,
              language,
              isChild: true,
              index: data.originIndex,
              cleanLayout
            })))
          return newItem
        }))
        carouselItems.map(newItem => newContainer.appendChild(newItem))
        return newContainer
      }))
      carouselContainers.map(newContainer => getElement[0].appendChild(newContainer))
    } else if (item.isPaginator) {
      // Paginador deshabilitado temporalmente. Todas las tarjetas se colocan
      // en una sola página para conservar su orden y permitir su edición.
      // const foramatData = getValue.reduce((accum, data, index) => {
      //   if (index % item.optionPaginator.itemsBySlider === 0 ) {
      //     accum.push([{...data, originIndex: index}])
      //   } else {
      //     accum[accum.length - 1].push({...data, originIndex: index})
      //   }
      //   return accum
      // },[])
      const foramatData = [getValue.map((data, index) => ({...data, originIndex: index}))]
      const copyC = getContainerOneElement(getElement, item, cleanLayout)
      if (!copyC) return false
      const copyContainer = copyC.cloneNode(true)

      const parentElement = copyContainer.querySelector(`.${item.containerParentPage}`).cloneNode(true);
      const copyParent = parentElement.cloneNode(true)

      
      const copyI = copyParent.querySelector(`.${item.optionPaginator.classitem}`).cloneNode(true);
      const copyItem = copyI.cloneNode(true)

      getElement[0].innerHTML = ""
      copyParent.innerHTML = ""
      copyContainer.innerHTML = ""

      const pageContainers = await Promise.all(foramatData.map(async (grouop) => {
        const newContainer = copyContainer.cloneNode(true)
        // setPaginatorClassItems(newContainer, item, indexGroup)
        // Sin los inputs de paginación, la regla CSS de .compPage ocultaría
        // las tarjetas. Se retira esa clase mientras siga deshabilitado.
        newContainer.classList.remove('compPage')
        const newParent = copyParent.cloneNode(true)
        const pageItems = await Promise.all(grouop.map(async data => {
          const newItem = copyItem.cloneNode(true)
          await Promise.all(item.childrenClass.map(option => setValuesIntoHtmlSection({
              item: option,
              cloneLayout: newItem,
              state,
              language,
              isChild: true,
              index: data.originIndex,
              cleanLayout
            })))
          return newItem
        }))
        pageItems.map(newItem => newParent.appendChild(newItem))
        newContainer.appendChild(newParent)
        return newContainer
      }))
      pageContainers.map(newContainer => getElement[0].appendChild(newContainer))
      // Generación del paginador deshabilitada temporalmente.
      // setPaginatorInputs(getElement, foramatData)
      // setPaginatorClassTabs(getElement, foramatData)


    } else if (item.isTabsDescription) {

      const copy = getContainerOneElement(getElement, item, cleanLayout)
      if (!copy) return false
      const newElement = copy.cloneNode(true)

      getElement[0].innerHTML = ""
      setTabsDescripcionInputs(getElement, getValue, item, data)
      setTabsDescripcionClassTabs(getElement, getValue, item, data)

      const tabElements = await Promise.all(getValue.map(async (_childValues, index) => {
        const copyElement = newElement.cloneNode(true)
        copyElement.classList.remove('tabCont1');
        copyElement.classList.add(`tabCont${index + 1}`);

        await Promise.all(item.childrenClass.map(option => setValuesIntoHtmlSection({
            item: option,
            cloneLayout: copyElement,
            state,
            language,
            isChild: true,
            index,
            cleanLayout
           })))
        return copyElement
      }))
      tabElements.map(copyElement => getElement[0].appendChild(copyElement))


    }else {
      const copy = getContainerOneElement(getElement, item, cleanLayout)
      if (!copy) return false
      const newElement = copy.cloneNode(true)
      getElement[0].innerHTML = ""
      if(item.isBullet) {
        const containerIndictors = cloneLayout.getElementsByClassName(item.optionBullet.classIndicator)
        setBulletsInputs(containerIndictors, getValue, item, data)
        setBulletsClassTabs(containerIndictors, getValue, item, data)
      }

      const childElements = await Promise.all(getValue.map(async (_childValues, index) => {
        const copyElement = newElement.cloneNode(true)
        if (item.isCarousel && index > 0) copyElement.classList.remove("active");
        if(item.isFrecuentQuestion) setFrecuenteQuestionsIndicators(copyElement, item, index)
        if(item.isBullet) {
          setBulletsClassItems(copyElement, item, index)
        }
        await Promise.all(item.childrenClass.map(option => setValuesIntoHtmlSection({
            item: option,
            cloneLayout: copyElement,
            state,
            language,
            isChild: true,
            index,
            cleanLayout
           })))
        return copyElement
      }))
      childElements.map(copyElement => getElement[0].appendChild(copyElement))
    }
    return true
  }

  let elementIsRemoved = false
  if (item.isRemove) elementIsRemoved = !removeElement(getElement, item, language, state, isChild ? index : null)

  if (!elementIsRemoved) {
    if(item.options) setOptions(getElement, item.options, language, state, isChild ? index : null)
    if (!item.onlyOptions) {
      if (item.isImg) await setImage(getElement, getValue)
      else if (item.isImgBackground) await setImageBackground(getElement, getValue)
      else if (item.isCustomText) await setCustomText(getElement, getValue)
      else setSimpleText(getElement, getValue)
    }
  }
  return getElement
}

const validateStateValue = ({value, defaultValue, language, stateGeneral, index = 0}) => {
  let newValue = value
  let newValueDefault = value
  if (newValue && newValue.includes('$language')) newValue = newValue.replace('$language', language)
  if (newValue && newValue.includes('$index')) newValue = newValue.replace('$index', index)
  if (newValueDefault && newValueDefault.includes('$language')) newValueDefault = newValueDefault.replace('$language', LANGUAGE_DEFAULT)
  if (newValueDefault && newValueDefault.includes('$index')) newValueDefault = newValueDefault.replace('$index', index)
  const valueDefault = get(stateGeneral, newValueDefault, defaultValue)
  let getValue = get(stateGeneral, newValue, null)
  if (!getValue || getValue === "\n") getValue = valueDefault
  return getValue
}

const setSimpleText = (element, value) => {
  element[0].innerText  = value
  return element
}
const setCustomText = (element, value) => {
  element[0].innerHTML  = value
  return element
}

const setOptions = (element, optionslink , language, section, index) => optionslink.map(item => {
  const data = {
    value:item.valueState,
    language,
    defaultValue: item.defaultValue,
    stateGeneral: section
  }
  if (index !== null) data.index = index
  const getValue = validateStateValue(data)

  if(element[0] && element[0].className.includes("sct-processes-item-button-link") && (item.property === "disabled" || item.property === "hide")){
    if(getValue.toString() === "true" && item.property === "disabled"){
      element[0].classList.add("sct-processes-item-button-link-disabled")
    }
    if(getValue.toString() === "true" && item.property === "hide"){
      return element[0].style.display = 'none'
    }
  }

  return element[0].setAttribute(item.property,  getValue)
})

const setImageBackground = async (element, value) => {
  const img64 = await toBase64(value[0].file)
  element[0].style.backgroundImage = `url(${img64})`
  return element
}

const setImage = async (element, value) => {
  const img64 = await toBase64(value[0].file)
  element[0].src = img64
  return element
}

const removeElement = (element, item, language, section, index) => {
  const data = {
    value:item.valueRemove,
    language,
    defaultValue: '',
    stateGeneral: section
  }
  if (index !== null) data.index = index
  const getValueRemove = validateStateValue(data)
  if (!getValueRemove) {
    while (element.length > 0) {
      element[0].remove();
    }
  }
  return getValueRemove
}

const setCarouselIndicators = (element, item, cloneLayout) => {
  const getContainerIndicator = cloneLayout.getElementsByClassName(item.optionCarousel.classIndicator)
  const getFirstIndicator = getContainerIndicator[0].children[0].cloneNode(true)
  getContainerIndicator[0].innerHTML = ""
  const quatityIndicators = element.length / item.optionCarousel.itemsBySlider
  range(quatityIndicators).map((_x, index) => {
    const elementIndicator = getFirstIndicator.cloneNode(true)
    elementIndicator.setAttribute('data-slide-to', index)
    if (index > 0) elementIndicator.classList.remove("active");
    getContainerIndicator[0].appendChild(elementIndicator)
  })
}

const setFrecuenteQuestionsIndicators = (element, item, index) => {
  const heading = element.getElementsByClassName(item.optionFrecuentQuestion.classHeading)
  heading[0].id = `${heading[0].id}${index}`
  const collapse = element.getElementsByClassName(item.optionFrecuentQuestion.classCollapse)
  collapse[0].id = `${collapse[0].id}${index}`
  const href = element.getElementsByClassName(item.optionFrecuentQuestion.classHref)
  href[0].href = `#${collapse[0].id}`
  return element
}

/* Lógica del paginador deshabilitada temporalmente.
const setPaginatorClassItems = (element, item, index) => {
  element.classList.remove(item.optionPaginator.classitemDynamic);
  element.classList.add(item.optionPaginator.classitemDynamic + (index + 1) );
}

const setPaginatorClassTabs = (container, cards) => {
  const divPArendNav = document.createElement('div')
  divPArendNav.classList.add("compPagNav")
  const divParentDots = document.createElement('div')
  divParentDots.classList.add("compPagNavDots")
  cards.map((_item, index) => {
    const label = document.createElement('label')
    label.htmlFor = `page${index + 1 }`
    label.classList.add(`page${index + 1}` );
    divParentDots.appendChild(label)
  })
  divPArendNav.appendChild(divParentDots)
  return container[0].appendChild(divPArendNav)
}

const setPaginatorInputs = (container, cards) => {
  cards.map((_card, indexData) => {
    const inp = document.createElement('input')
    inp.type = "radio"
    inp.name = "cpagination"
    inp.id = `page${indexData + 1 }`
    inp.classList.add(`pagRadio${indexData + 1}` );
    inp.checked = 'true'

    if (!indexData) {
      inp.setAttribute("checked", true)
    }

    return container[0].prepend(inp)
  })
}
*/

const setBulletsClassItems = (element, item, index) => {
  element.classList.remove(item.optionBullet.classitemDynamic);
  element.classList.add(item.optionBullet.classitemDynamic + (index + 1) );
}

const setBulletsInputs = (container, cards, item, data) => {
  const inputItem = container[0].getElementsByTagName('input')
  const inputCopy = inputItem[0].cloneNode(true)
  inputItem[0].remove()
  cards.map((card, indexData) => {
    const inputPaginator = inputCopy.cloneNode(true)
    inputPaginator.id = `page${cards.length - indexData }`
    inputPaginator.classList.remove('pagRadio');
    inputPaginator.checked = 'true'
    if ((indexData + 1) === cards.length ) {
      inputPaginator.setAttribute("checked", "")
    }
    inputPaginator.classList.add(`pagRadio${cards.length - indexData}` );
    container[0].prepend(inputPaginator)
  })
}

const setBulletsClassTabs = (container, cards, item, data) => {
  const tabsContainer = container[0].getElementsByClassName(item.optionBullet.classTabs)
  const getFirstIndicator = tabsContainer[0].children[0].cloneNode(true)
  tabsContainer[0].innerHTML = ""
  // getFirstIndicator = <label for="page1" class="page1 sct-bullets-content-tabs-item">Honestidad</label>
  cards.map((card, indexData) => {
    let formatData = data
    formatData.defaultValue = ""
    formatData.value= "bullets.cards[$index].$language.title"
    formatData.index= indexData
    const getValue = validateStateValue(formatData)

    const elementIndicator = getFirstIndicator.cloneNode(true)

    elementIndicator.htmlFor = `page${indexData + 1 }`
    elementIndicator.classList.remove('page');
    elementIndicator.classList.add(`page${indexData + 1}` );
    elementIndicator.innerText = getValue
    tabsContainer[0].appendChild(elementIndicator)

  })
}

const setTabsDescripcionInputs = (container, cards, item, data) => cards.map((card, indexData) => {
    const inputItem = document.createElement("input")
    inputItem.type = "radio";
    inputItem.name = "mtab";
    inputItem.id = `tab${cards.length - indexData }`
    inputItem.checked = 'true'
    if ((indexData + 1) === cards.length ) {
      inputItem.setAttribute("checked", "")
    }
    inputItem.classList.add(`tabInput${cards.length - indexData}` );
    container[0].prepend(inputItem)
  })

const setTabsDescripcionClassTabs = (container, cards, item, data) => {
  const divTabMenu = document.createElement('div')
  divTabMenu.classList.add("modTabsMenu")
  const divContainer = document.createElement('div')
  divContainer.classList.add("container")
  const divTabsLabel = document.createElement('div')
  divTabsLabel.classList.add("modTabsMenuLabels")
  cards.map((card, indexData) => {
    const labelTab = document.createElement("label")

    const formatData = data
    formatData.defaultValue = ""
    formatData.value= "tabsDescripcion.cards[$index].$language.title"
    formatData.index= indexData
    const getValue = validateStateValue(formatData)


    labelTab.htmlFor = `tab${indexData + 1 }`
    labelTab.classList.add(`tabBtn${indexData + 1}` );
    labelTab.innerHTML = `<strong>${getValue}</strong>`
    divTabsLabel.appendChild(labelTab)
  })
  divContainer.appendChild(divTabsLabel)
  divTabMenu.appendChild(divContainer)
  return container[0].appendChild(divTabMenu)
}

export const setInfoFilterComponent = async ({cloneLayout, state, sectionItem, language}) => {
  const { selectedNavegationTree } = state
  const divData = cloneLayout.getElementsByClassName(sectionItem.parentClass.class)[0].getElementsByClassName('filterDocumentsId')
  divData[0].setAttribute("data-id", selectedNavegationTree)
  divData[0].setAttribute("data-language", language)
  divData[0].id= selectedNavegationTree
}


export const _setValuesIntoHtmlSection = async (getElement, item, _section, language) => {
  let stateValue = item.valueState
  if (stateValue && stateValue.includes('$language')) stateValue = stateValue.replace('$language', language)
  const getValue = get(_section, stateValue, item.defaultValue)
  if (item.isDinamyc && item?.childrenClass) {
    const copy = getElement[0].querySelector(`.${item.containerOneClass}`).cloneNode(true);
    const newElement = copy.cloneNode(true)
    getElement[0].innerHTML = ""

    if ( getValue && getValue.length) {
      getValue.map(async childValues => {
        const copyElement = newElement.cloneNode(true)
        item.childrenClass.map(async option => {
          const formatValue = option.valueState.split('.')
          const valueStateChild = formatValue[formatValue.length - 1]
          const getChild = copyElement.getElementsByClassName(option.class)
          if (childValues[valueStateChild] && childValues[valueStateChild].includes('<') && childValues[valueStateChild].includes('</')) getChild[0].innerHTML  = childValues[valueStateChild]
          else if (option.isLink) {
            const formatValueLink = option.valueLink.split('.')
            const valueStateChildLink = formatValueLink[formatValueLink.length - 1]
            getChild[0].href = childValues[valueStateChildLink]
            getChild[0].innerText = childValues[valueStateChild]
          } else if (option.isImg) {
            const img64 = await toBase64(childValues[valueStateChild][0].file)
            getChild[0].src = img64
          }
          else getChild[0].innerText = childValues[valueStateChild]
        })
        getElement[0].appendChild(copyElement)
      })
    }
    return true
  }
  
  if (item.isRemove) {
    const getValueRemove = get(_section, item.valueRemove)
    if (!getValueRemove) {
      while (getElement.length > 0) {
        getElement[0].remove();
      }
      return true
    }
  }

  if (getValue && getValue.includes('<')  && getValue.includes('</')) getElement[0].innerHTML  = getValue
  else if (item.isImg) {
    const img64 = await toBase64(getValue[0].file)
    getElement[0].src = img64
  }
  else getElement[0].innerText = getValue
  return getElement
}

export const getValuesIntoHtmlSection = async ({option, html, stateComponents, language, isChild = false, index}) => {
  const getElement = html.getElementsByClassName(option.class)
  const data = {
    stateValue: option.valueState,
    language,
  }
  if (isChild) data.index = index

  const stateValue = validateValue(data)
  let getValueOfElement = ''

  if (option.childrenClass) {
    if (option.isCarousel) { // Carrusel
      const getSliders = getElement[0].children
      return Array.from(getSliders).forEach((slidersTag, sliderIndex) => {
        const getItems = slidersTag.children
        return Array.from(getItems).forEach((childrenItem, itemsIndex) => {
          option.childrenClass.map( async (optionChildren) => {
              getValuesIntoHtmlSection({
                option: optionChildren,
                html: childrenItem,
                stateComponents,
                language,
                isChild: true,
                index: (option.optionCarousel.itemsBySlider * sliderIndex) + itemsIndex
              })
            })
        })
      })
      // })
    }
    if (option.isPaginator) {
      const getSliders = getElement[0].getElementsByClassName(option.containerOneClass)
      return Array.from(getSliders).forEach((slidersTag, sliderIndex) => {
        const getItems = slidersTag.children[0].children
        return Array.from(getItems).forEach((childrenItem, itemsIndex) => {
          option.childrenClass.map( async (optionChildren) => {
              getValuesIntoHtmlSection({
                option: optionChildren,
                html: childrenItem,
                stateComponents,
                language,
                isChild: true,
                index: (option.optionPaginator.itemsBySlider * sliderIndex) + itemsIndex
              })
            })
        })
      })
    }
    if (option.isTabsDescription) {
      const getTabs = getElement[0].getElementsByClassName(option.containerOneClass)
      return Array.from(getTabs).forEach((childrenTag, index) => {
        option.childrenClass.map( async (optionChildren) => {
  
          getValuesIntoHtmlSection({
            option: optionChildren,
            html: childrenTag,
            stateComponents,
            language,
            isChild: true,
            index
          })
        })
      })
    }
      // Preguntas frecuentes
      return getElement[0].childNodes.forEach((childrenTag, index) => {
        option.childrenClass.map( async (optionChildren) => {
  
          getValuesIntoHtmlSection({
            option: optionChildren,
            html: childrenTag,
            stateComponents,
            language,
            isChild: true,
            index
          })
        })
      })
    
  }

  let elementRemoved = false
  if (option.isRemove) elementRemoved = !getRemoveElement(getElement, option, stateComponents, language, isChild ? index : null)

  if (!elementRemoved) {
    if(option.options) getOptions(getElement, option.options, stateComponents, language, isChild ? index : null)
    if (!option.onlyOptions) {
      if (option.isImg && getElement) getValueOfElement = getImage(getElement, option)
      else if (option.isImgBackground && getElement) getValueOfElement = getImgBackground(getElement, option)
      else if (option.isCustomText) getValueOfElement = getCustomText(getElement, option)
      else if (option.isTextArea) getValueOfElement = getTextOfArea(getElement, option)
      else getValueOfElement = getSimpleText(getElement, option)
      set(stateComponents, stateValue, getValueOfElement)
    }
  }

  return stateComponents
}

const validateValue = ({stateValue, language, index = 0}) => {
  if (stateValue?.includes('$language')) stateValue = stateValue.replace('$language', language)
  if (stateValue && stateValue?.includes('$index')) stateValue = stateValue.replace('$index', index)
  return stateValue
}

const getSimpleText = (getElement, option) => (getElement && getElement.length && getElement[0].innerText) || option.defaultValue

const getCustomText = (getElement, option) => (getElement && getElement.length && getElement[0].innerHTML) || option.defaultValue
const getTextOfArea = (getElement, option) => {
  let value = getElement && getElement.length && getElement[0].innerHTML || option.defaultValue
  if (value) value = value.replace(/<br>/g, '\n')
  return value
}

const getImgBackground = (getElement, option) => {
  let getImg = getElement[0].style.backgroundImage
  getImg = getImg.split(/"/)[1]
  const file = getBase64Image(getImg, 'base')
  const localUrl = URL.createObjectURL(file);
  const formatImg = [
    {
      fileName: 'img-background',
      currentValue: localUrl,
      file
    }
  ]
  return formatImg || option.defaultValue
}

const getImage = (getElement, option) => {
  const getImg = getElement[0].src
  const file = getBase64Image(getImg, 'base')
  const localUrl = URL.createObjectURL(file);
  const formatImg = [
    {
      fileName: 'img-block',
      currentValue: localUrl,
      file
    }
  ]
  return formatImg || option.defaultValue
}

const getOptions = (getElement, optionsParameter, stateComponents, language, index) => optionsParameter.map(item => {
    const data = {
      stateValue: item.valueState,
      language
    }
    if (index !== null) data.index = index
    const stateValue = validateValue(data)
    let getValueIntoTag = ''
    if (getElement && getElement.length) getValueIntoTag = getElement[0].getAttribute(item.property) || item.defaultValue
    return set(stateComponents, stateValue, getValueIntoTag)
  })

const getRemoveElement = (getElement, option, stateComponents, language, index) => {
  const data = {
    stateValue: option.valueRemove,
    language
  }
  if (index !== null) data.index = index
  const stateValue = validateValue(data)
  set(stateComponents, stateValue, !!getElement.length)
  return !!getElement.length
}

export const getValueLanguageObj = (object, especificLanguage = null) => {
  // { es: 'Valor 1', en: "Value 1" }
  if (typeof object === "object") {
    const getCurrentLanguage = especificLanguage || i18n.language
    return object[getCurrentLanguage] || object[LANGUAGE_DEFAULT]
  }
  return ""
}

const createModalFormattedText = ({html, modalBody, id}) => {
  const modal = html.getElementsByClassName('sct-category-modal')
  const newModal = modal[0].cloneNode(true)
  newModal.setAttribute('id', id)
  const body = newModal.getElementsByClassName('sct-category-modal-body', )
  setCustomText(body, modalBody)
  const container = html.getElementsByClassName('sct-category')
  return container[0].appendChild(newModal)
}

export const setDocumentsList = ({html, language, data}) => {
  const container = html.getElementsByClassName('sct-category-container')
  const content = html.getElementsByClassName('sct-category-content')
  const cloneContent = content[0].cloneNode(true)
  container[0].innerHTML = ""
  data.map(item => {
    const newContent = cloneContent.cloneNode(true)
    const titleSection = newContent.getElementsByClassName('sct-category-title')
    titleSection[0].innerText = item.titleSection

    const cardsContent = newContent.getElementsByClassName('sct-category-cards-content')
    const cardDocument = newContent.getElementsByClassName('sct-category-card')
    const cloneCard = cardDocument[0].cloneNode(true)
    cardsContent[0].innerHTML = ""

    item.documents.map(doc => {
      const formatDate = getDateWhMonthLanguage({date: doc.publicationDate, lng: language})
      const cardNew = cloneCard.cloneNode(true)
      cardNew.getElementsByClassName('sct-category-card-publication-date')[0].innerText = formatDate
      cardNew.getElementsByClassName('sct-category-card-title')[0].innerText = doc.name[language] || doc.name[LANGUAGE_DEFAULT]
      cardNew.getElementsByClassName('sct-category-card-description')[0].innerText =  doc.description[language] || doc.description[LANGUAGE_DEFAULT]
      const hrefRight = cardNew.getElementsByClassName('sct-category-card-link-right')
      const hrefLeft = cardNew.getElementsByClassName('sct-category-card-link-left')


      if (doc.typeDocument === TypeDocuments.IS_LINK) {
        cardNew.getElementsByClassName('sct-category-card-publication-icon')[0].classList.add("link");
        const options = [
          { property: 'href', valueState: 'urlLink', defaultValue: ''  },
          { property: 'target', valueState: 'urlTarget', defaultValue: '_blank'  }
        ]
        setOptions( hrefRight, options , language, doc)
        hrefLeft[0].style.display = "none"
        hrefRight[0].style.display = "block"
      } else if (doc.typeDocument === TypeDocuments.IS_DOCUMENT_PDF) {
        cardNew.getElementsByClassName('sct-category-card-publication-icon')[0].classList.add("pdf")
        const options = [
          { property: 'href', valueState: 'file.$language', defaultValue: ''  },
          { property: 'download', valueState: '', defaultValue: ''  }
        ]
        setOptions( hrefLeft, options , language, doc)
        hrefLeft[0].style.display = "block"
        hrefRight[0].style.display = "none"
      } else if (doc.typeDocument === TypeDocuments.IS_FORMATTED_TEXT) {
        cardNew.getElementsByClassName('sct-category-card-publication-icon')[0].classList.add("html")
        const idHref = `modal-${Math.floor(Math.random()*100) + 5}`
        createModalFormattedText({
          html,
          modalBody: doc.formattedText[language] || doc.formattedText[LANGUAGE_DEFAULT],
          id: idHref
        })
        hrefRight[0].setAttribute('data-toggle', 'modal')
        hrefRight[0].setAttribute('data-target', `#${idHref}`)
        hrefLeft[0].style.display = "none"
        hrefRight[0].style.display = "block"
      }
      return cardsContent[0].appendChild(cardNew)
    })
    container[0].appendChild(newContent)
    return html
  })
}

export const setNewDocument = async ({html, language, state}) => {
  const getcardDocument = html.querySelector('.sct-category-card')
  const newCardDocument = getcardDocument.cloneNode(true)
  const hrefRight = newCardDocument.getElementsByClassName('sct-category-card-link-right')
  const hrefLeft = newCardDocument.getElementsByClassName('sct-category-card-link-left')

  if (state.general.typeDocument === TypeDocuments.IS_LINK) {
    newCardDocument.getElementsByClassName('sct-category-card-publication-icon')[0].classList.add("link");
    const options = [
      { property: 'href', valueState: 'content.link.url', defaultValue: ''  },
      { property: 'target', valueState: 'content.link.target', defaultValue: '_blank'  }
    ]
    setOptions( hrefRight, options , language, state)
    hrefLeft[0].style.display = "none"
    hrefRight[0].style.display = "block"
  } else if (state.general.typeDocument === TypeDocuments.IS_DOCUMENT_PDF) {
    newCardDocument.getElementsByClassName('sct-category-card-publication-icon')[0].classList.add("pdf")
    const options = [
      { property: 'href', valueState: 'content.document.$language.file[0].currentValue', defaultValue: ''  },
      { property: 'download', valueState: '', defaultValue: ''  }
    ]
    setOptions( hrefLeft, options , language, state)
    hrefLeft[0].style.display = "block"
    hrefRight[0].style.display = "none"
  } else if (state.general.typeDocument === TypeDocuments.IS_FORMATTED_TEXT) {
    newCardDocument.getElementsByClassName('sct-category-card-publication-icon')[0].classList.add("html")
    const idHref = `modal-${Math.floor(Math.random()*100) +5}`
    hrefLeft[0].style.display = "none"
    hrefRight[0].style.display = "block"
    hrefRight[0].setAttribute('data-toggle', 'modal')
    hrefRight[0].setAttribute('data-target', `#${idHref}`)
    createModalFormattedText({
      html,
      modalBody: validateStateValue({ value: 'content.formattedText.$language.description', defaultValue: '', language, stateGeneral: state}),
      id: idHref
    })
  }

  setSimpleText(newCardDocument.getElementsByClassName('sct-category-card-title'), validateStateValue({ value: 'general.$language.name', defaultValue: '', language, stateGeneral: state}))
  setSimpleText(newCardDocument.getElementsByClassName('sct-category-card-description'), validateStateValue({ value: 'general.$language.description', defaultValue: '', language, stateGeneral: state}))
  let publicationDate = validateStateValue({ value: 'general.publicationDate', defaultValue: '', language, stateGeneral: state})
  publicationDate = getDateWhMonthLanguage({date: publicationDate, lng: language})

  setSimpleText(newCardDocument.getElementsByClassName('sct-category-card-publication-date'), publicationDate)

  const contentCards = html.getElementsByClassName('sct-category-cards-content')
  contentCards[0].appendChild(newCardDocument)

  return html
}

export const mergeHtmlToFinalLayout = (htmlgenerate, title = '', componentsSelected = [], options = {}) => {
  const isHomeAliadosTemplate = options.templateType === SECTION_TEMPLATE_TYPES.HOME_ALIADOS
  const preserveDocument = options.preserveDocument === true
  const layout = htmlgenerate.cloneNode(true)
  const hasUltimosDocumentos = componentsSelected.find(sectionItem => sectionItem.componentName === "UltimosDocumentosAgregadosComponent" )
  const homeDocsSliderCarousel = layout.getElementsByClassName('homeDocsSliderCarousel')[0]
  if (hasUltimosDocumentos && homeDocsSliderCarousel) homeDocsSliderCarousel.innerHTML = ""

  let getTemplateThymeleaf
  if (preserveDocument) {
    const titleElement = layout.getElementsByTagName('title')[0]
    if (titleElement) titleElement.innerText = title
    getTemplateThymeleaf = `<!DOCTYPE html>${layout.outerHTML}`
  } else {
    getTemplateThymeleaf = isHomeAliadosTemplate ? htmlTemplates[8].templete : htmlTemplates[3].templete;
    getTemplateThymeleaf = getTemplateThymeleaf.replace("<title></title>", `<title>${title}</title>`)
    const getMainElement = layout.getElementsByTagName('main')[0].outerHTML
    getTemplateThymeleaf = getTemplateThymeleaf.replace(`<main class="wrapper wfix dynamic-elements-content"></main>`, getMainElement)
  }

  // Validar Scrips por componentes seleccionados Start
  
  // @ProcesssCards
  // const hasProcessCards = componentsSelected.find(sectionItem => sectionItem.componentName === "ProcesssCards" )
  // if (!hasProcessCards) getTemplateThymeleaf.replace(`<script th:src="@{/script/proceso/proceso-global.1.0.js}"></script>`, '')
  // @Ultimos Documentos
  if (!hasUltimosDocumentos) {
    getTemplateThymeleaf = getTemplateThymeleaf.replace(`<script th:src="@{/script/ultimosDocumentos/ultimosDocumentos.js}" type="module"></script>`, '')
    getTemplateThymeleaf = getTemplateThymeleaf.replace(`$('.homeDocsSliderCarousel').slick({ autoplay: true, autoplaySpeed: 5000, speed: 1000, slidesToShow: 3, slidesToScroll: 1, dots: false});`, '')
  }

  if (isHomeAliadosTemplate && !componentsSelected.find(sectionItem => sectionItem.componentName === "BannerCodeEthics")) {
    getTemplateThymeleaf = getTemplateThymeleaf.replace(`<script th:src="@{/script/code-ethics.js}" type="module"></script>`, '')
  }
  
  // Validar Scrips por componentes seleccionados End

  return getTemplateThymeleaf

}

export const mergeEmailToFinalLayout = (plantillaEmail) => {
  let getTemplateEmail = htmlTemplates[4].templete;
  // console.log('plantillaEmail', plantillaEmail)
  const html = document.createElement( 'html' );
  html.innerHTML = plantillaEmail
  const getMainTable = html.getElementsByTagName('table')[0].outerHTML
  getTemplateEmail = getTemplateEmail.replace(`<!--Insertar Codigo Generado--!>`, getMainTable)

  return getTemplateEmail

}

export const mergeDigitalFormToFinalLayout = (plantillaDiditalForm) => {
  let getTemplateDigitalForm = htmlTemplates[7].templete;
  // console.log('plantillaEmail', plantillaEmail)
  const html = document.createElement( 'html' );
  html.innerHTML = plantillaDiditalForm
  const getMainElement = html.getElementsByClassName(MAIN_CLASS_HTML_DIGITAL_FORM)[0].outerHTML
  getTemplateDigitalForm = getTemplateDigitalForm.replace(`<main class="wrapper wfix dynamic-elements-content"></main>`, getMainElement)

  return getTemplateDigitalForm
}

export const setConfigCalendarLanguage = (detail) => detail.map(language => {
    const dayNames = DAY_NAMES.map(item => i18n.t(item, {lng: language.clave }))
    const dayNamesMin = dayNames.map(item => item[0].toUpperCase())
    const monthNames = MONTH_NAMES.map(item => i18n.t(`${item}`, {lng: language.clave }))
    return addLocale(language.clave, {
      firstDayOfWeek: 1,
      dayNames,
      dayNamesMin,
      monthNames,
  });
  })

export const getDateWhMonthLanguage = ({ date, lng, format = 'DD MMMM YYYY' }) => {
  const monthNumber = moment(date).format('M')
  const getNameMonth = MONTH_NAMES[monthNumber - 1]
  let traslateMonth = ''
  if (lng) traslateMonth = i18n.t(getNameMonth, { lng: lng })
  else traslateMonth = i18n.t(getNameMonth)
  const newFormat = format.replace('MMMM', `[${traslateMonth}]`)
  const formatDate = moment(date).format(newFormat)
  return formatDate
}

export const findSectionInTree = (key, items) => {  
  var i = 0, found;
  for (; i < items.length; i++) {
    if (items[i].key === key) {
      return items[i];
    } if (isArray(items[i].children)) {
      found = findSectionInTree(key, items[i].children);
      if (found) {
        return found;
      }
    }
  }
}

export const getLabelCompleteInTree = (data, id, string) => {
  const getItem = findSectionInTree(id, data)
  let newString = ""
  if (!string) newString = `${getItem?.label}`
  else newString = `${getItem?.label}/${string}`
  
  if (getItem.parentKey) return getLabelCompleteInTree(data, getItem.parentKey, newString)
  return newString
}

export const getLabelCompleteInTreeES = (data, id, string = "") => {
  if (!id || id === 0) {
    return string
  }

  const getItem = findSectionInTree(id, data)

  if (!getItem) {
    console.warn("No se encontró nodo para id:", id)
    return string
  }

  const label = getItem?.nombre?.[LANGUAGE_DEFAULT] || getItem?.label || ""

  const newString = string
    ? `${label}/${string}`
    : label

  if (getItem?.parentKey) {
    return getLabelCompleteInTreeES(data, getItem.parentKey, newString)
  }

  return newString
}

export const formatJsonId = (array) => array.map(item => ({id: item}))

export const snakeCaseString = (str) => str && str.match(
/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
      .map(s => s.toLowerCase())
      .join('_')
